import { optionSchema } from "@/common/schemas/option.schema";
import { z } from "zod"

export const createSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' }),
  kind: optionSchema,
  expiration_date: z.string()
    .optional()
    .refine((value) => {
      if(!value) return true
      const [day, month, year] = value.split('/');
      if(Number(day) > 31 || Number(month) > 12){
        return 
      }
      const valueDate = new Date([month, day, year].join('/'));
      const today = new Date();
      return valueDate > today
    }, { message: 'Data deve ser válida e superior à hoje' }),
  // assign_as_license: z.boolean()
})

export type GeneralDocumentValidationSchema = z.infer<typeof createSchema>